var map = {
	"./blue_curve.png": 35,
	"./bus.png": 10,
	"./gas.jpg": 36,
	"./gas2.jpg": 37,
	"./hamb.png": 38,
	"./logo.png": 11,
	"./products": 3,
	"./products.json": 3,
	"./test": 17,
	"./test.js": 17
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34;